<template>
    <v-tab-item :value="thisTab" class="fill-height pa-16">
        <v-layout column justify-center align-center class="h-100 mx-auto" style="max-width: 1224px">
            <v-sheet style="flex: 1 1 auto; overflow-x: hidden; overflow-y: auto" class="scroll-primary px-10">
                <v-card flat tile class="py-20">
                    <v-layout justify-center align-center class="pt-16 px-16">
                        <v-icon size="80" >mdi-file-document-check-outline</v-icon>
                    </v-layout>
                    <v-card-title class="d-flex justify-center">
                        근로계약 전자서명에 대한 동의
                    </v-card-title>
                    <v-card-text>
                        <v-card outlined flat tile>
                            <v-card-text>
                                <ul class="pl-20" style="list-style-type: square;">
                                    <li>전자서명 및 전자문서의 법적 효력에 대해 동의합니다.</li>
                                    <li>서명 완료 후 전송되는 전자문서를 원본으로 인정합니다.</li>
                                    <li>모든 서명자가 전자서명에 정당한 권한을 가지는 것을 확인했습니다.</li>
                                    <li>기타 자세한 내용은 전자서명 이용약관에 따라 동의합니다.</li>
                                </ul>
                            </v-card-text>
                        </v-card>
                    </v-card-text>
                </v-card>
            </v-sheet>
            <div class="v-btn-group flex-wrap my-12">
                <v-btn
                    outlined
                    color="grey-d"
                    class="min-w-140px min-w-lg-160px"
                    v-bind="{
                        loading,
                    }"
                    @click="$emit('prev')"
                >
                    <v-icon color="grey-6">mdi-chevron-left</v-icon>
                    <span class="grey-6--text"> 이전 단계 </span>
                </v-btn>
                <v-btn
                    color="primary"
                    class="min-w-140px min-w-lg-160px"
                    v-bind="{
                        loading,
                    }"
                    @click="$emit('save')"
                >
                    <span> 동의하고 서명 완료 </span>
                    <v-icon style="color:white!important">mdi-chevron-right</v-icon>
                </v-btn>
            </div>
        </v-layout>
    </v-tab-item>
</template>

<script>
import { initEmploymentContract } from "@/assets/variables";

import { TABS } from "../lib";

const thisTab = TABS.SAVE.value;

export default {
    props: {
        /** @type {import('vue').PropType<import('@/assets/variables').EmploymentContract>} */
        value: { type: Object, default: initEmploymentContract },
        tab: { type: String, default: TABS.VIEW.value },
        shows: { type: Boolean, default: false },
        loading: { type: Boolean, default: false },
    },
    data: () => ({
        thisTab,
    }),
};
</script>
